<template>
    <span>
        <form :action="action" method="POST" enctype="multipart/form-data" ref="form">
            <input type="hidden" name="_token" :value="csrfToken">
            <input type="file" :name="inputName" accept=".xml" class="d-none" ref="fileInput" @change="onFileChange">
            <button type="button" class="btn btn-primary btn-sm" @click="$refs.fileInput.click()">
                <i class="fa fa-upload me-1" aria-hidden="true"></i> {{ label }}
            </button>
        </form>
    </span>
</template>

<script>
export default {
    name: 'ImportStatementButton',

    props: {
        action: {
            type: String,
            required: true,
        },
        csrfToken: {
            type: String,
            required: true,
        },
        inputName: {
            type: String,
            default: 'statement',
        },
        label: {
            type: String,
            default: 'Import',
        },
    },

    methods: {
        onFileChange() {
            if (this.$refs.fileInput.files.length > 0) {
                this.$refs.form.submit();
            }
        },
    },
};
</script>
